import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeArrayProp, makeCustomProp, makeStringProp } from '@/utils';
import { Button, ButtonType, Icon, Image } from 'vant';
import { t } from '@/assets/theme';
import doctorAvatar from '@/assets/images/doctor.png';

const { name, bem } = createNamespaceBem('card-team');

const cardTeamProps = {
  data: makeCustomProp<any>(Object, null),
  header: makeStringProp(''),
  headerDesc: makeStringProp(''),
  headerActionText: makeStringProp('查看团队'),
  headerActionStatus: makeCustomProp<boolean>(Boolean, true),
  bodyList: makeArrayProp<{ name: string; thumbAvatar: string }>(),
  bodyInfoLabel: makeStringProp('团队擅长：'),
  bodyInfo: makeStringProp(''),
  bodyData: makeArrayProp<{ label: string; data: number | string }>(),
  footerBtn: makeArrayProp<{ text: string; theme: ButtonType }>(),
};

export type CardTeamProps = ExtractPropTypes<typeof cardTeamProps>;

export default defineComponent({
  name,
  props: cardTeamProps,
  emits: ['clickHeaderLink', 'clickFooterBtn'],
  setup(props, { emit, slots }) {
    const onClickHeaderLink = () => {
      emit('clickHeaderLink', props.data);
    };

    const onClickFooterBtn = () => {
      emit('clickFooterBtn', props.data);
    };
    const renderHeader = () => (
      <div class={bem('header')}>
        <div class={bem('header-left')}>
          {props.header}
          <span>{props.headerDesc}</span>
        </div>
        {props.headerActionStatus && (
          <div class={bem('header-right')} onClick={onClickHeaderLink}>
            {props.headerActionText}
            <Icon name="arrow" />
          </div>
        )}
      </div>
    );
    const renderBodyList = () => (
      <div class={bem('body-list')}>
        {props.bodyList.map((i) => (
          <div class={bem('body-list-item')}>
            <Image round lazyLoad src={i.thumbAvatar ? i.thumbAvatar : doctorAvatar} iconSize={t(14)} />
            <span>{i.name}</span>
          </div>
        ))}
      </div>
    );
    const renderBodyData = () => (
      <div class={bem('body-data')}>
        {props.bodyData.map((i) => (
          <div class={bem('body-data-item')}>
            <span>{i.label}</span>
            <span>{i.data}</span>
          </div>
        ))}
      </div>
    );
    const renderBody = () => (
      <div class={bem('body')}>
        {renderBodyList()}
        <div class={bem('body-info')}>
          {props.bodyInfoLabel}
          {props.bodyInfo}
        </div>
        {renderBodyData()}
      </div>
    );
    const renderFooter = () => {
      if (slots.footer) {
        return slots.footer();
      }
      return (
        <div class={bem('footer')}>
          {props.footerBtn.map((i) => (
            <Button size="small" type={i.theme} onClick={onClickFooterBtn}>
              {i.text}
            </Button>
          ))}
        </div>
      );
    };
    return () => (
      <div class={bem()}>
        {renderHeader()}
        {renderBody()}
        {renderFooter()}
      </div>
    );
  },
});
